import profileLocale from './en.json'

const en = {
  profile: profileLocale,
}

export default en
